import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AdminService } from 'src/app/services/admin.service';

@Component({
  selector: 'app-add-video',
  templateUrl: './add-video.component.html',
  styleUrls: ['./add-video.component.scss']
})
export class AddVideoComponent implements OnInit {
  videoForm!: FormGroup;
  loader: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AddVideoComponent>,
    private adminservice: AdminService
  ) { }

  ngOnInit() {
    this.formBuilder();
    if (this.data.session) {
      const data = {
        sessionId: this.data.session.id,
        title: this.data.session.titulo,
        description: this.data.session.descripcion,
        urlVideo: this.data.session.link_video,
        timeVideo: this.data.session.duracion_video
      }
      this.videoForm.patchValue(data)
    }
  }

  formBuilder(){
    this.videoForm = new FormGroup({
      sessionId: new FormControl(''),
      title: new FormControl('', Validators.required),
      description: new FormControl('', Validators.required),
      urlVideo: new FormControl('', Validators.required),
      timeVideo: new FormControl('60')
    });
  }

  saveDataCourse() {
    if (!this.videoForm.valid) {
      return
    }

    const request = {
      sesion_id: this.videoForm.value.sessionId,
      modulo_id: this.data.module.id,
      titulo: this.videoForm.value.title,
      descripcion: this.videoForm.value.description,
      link_video: this.videoForm.value.urlVideo,
      duracion_video: this.videoForm.value.timeVideo
    }
    this.loader = true;
    this.adminservice.saveSession(request).subscribe(
      (response)=>{
        this.loader = false;
        if (response.rtn) {
          this.dialogRef.close(true); 
        }
      }
    );
  }


}
